module.exports = __webpack_public_path__ + "static/media/newMessages-favicon.0cff49df.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/icons/newMessages-favicon.png
// module id = 568
// module chunks = 0